module.exports = __webpack_public_path__ + "img/enterprise-main03.4b9b3b44.jpg";